import { render } from "./ModalEditAccident.vue?vue&type=template&id=68bad632&scoped=true"
import script from "./ModalEditAccident.vue?vue&type=script&lang=js"
export * from "./ModalEditAccident.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-68bad632"

export default script